import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    id: '01',
    title: 'Free Inspection',
    desc: 'We assess your property and identify all pest activity and entry points.'
  }, {
    id: '02',
    title: 'Custom Plan',
    desc: 'A tailored treatment plan designed for your specific situation.'
  }, {
    id: '03',
    title: 'Treatment Day',
    desc: 'Our certified technicians execute the plan with precision and care.'
  }, {
    id: '04',
    title: 'Guaranteed Results',
    desc: 'We stand behind our work with a satisfaction guarantee.'
  }];
  return <section id="how-it-works" className="bg-brand-dark py-24 px-6" data-id="element-181">
      <div className="max-w-7xl mx-auto" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 text-center flex flex-col items-center" data-id="element-183">
          <div className="flex items-center gap-4 mb-4" data-id="element-184">
            <div className="w-10 h-[2px] bg-brand-green" data-id="element-185" />
            <span className="font-condensed uppercase text-brand-green tracking-widest font-semibold" data-id="element-186">
              How It Works
            </span>
            <div className="w-10 h-[2px] bg-brand-green" data-id="element-187" />
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-7xl text-white" data-id="element-188">
            THE PROCESS
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6 relative" data-id="element-189">
          {steps.map((step, index) => <motion.div key={step.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center sm:items-start sm:text-left lg:items-start lg:text-left" data-id="element-190">
              <div className="text-6xl md:text-8xl font-bebas text-brand-green/20 leading-none mb-2 md:mb-4" data-id="element-191">
                {step.id}
              </div>
              <h3 className="font-condensed uppercase text-xl md:text-2xl font-bold text-white mb-2 md:mb-3 tracking-wide" data-id="element-192">
                {step.title}
              </h3>
              <p className="font-barlow text-brand-gray text-base" data-id="element-193">
                {step.desc}
              </p>

              {/* Arrow connector for desktop */}
              {index < steps.length - 1 && <div className="hidden lg:block absolute top-10 -right-6 text-brand-green text-3xl font-light" data-id="element-194">
                  →
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}